import AppSettings from '../../app/AppSettings';
import { ShoppingContext, StoreContext } from '../../app/data/model';
import { LanguageCode } from '../../app/localization/LanguageCode';
import { getB2cOrigin } from '../../app/shared/getB2cOrigin';
import { BasePdfOriginProvider } from '../../app/shared/PdfUrlProvider';

export class B2bPdfUrlProvider extends BasePdfOriginProvider {
  constructor(settings: AppSettings) {
    super(settings);
  }

  protected getStoreAndLanguage(
    shoppingContext: ShoppingContext,
    storeContext: StoreContext,
  ): { storeId: string; languageCode: string } {
    const store = storeContext.store.origin ?? storeContext.store;
    const languageCode = LanguageCode.isAnyOf(shoppingContext.languageCode, store.languages)
      ? shoppingContext.languageCode
      : 'en-GB';

    return { storeId: store.id, languageCode };
  }

  protected get origin(): string {
    return getB2cOrigin(this.settings.baseUrl);
  }
}
